import React, { useMemo } from "react";

import { Grid } from "@material-ui/core";
import { Button, Datagrid, Labeled, TextField } from "react-admin";

import { AddIcon, EditIcon } from "../../../../components/common/iconography";
import { SortedArrayField } from "../../../../components/common/SortedArrayField";
import { deepRedirect } from "../../../../utils/utils";

const handleEdit = ({ record, history, backPath }) => {
  deepRedirect(history, `/eventTypes/${record.id}`, backPath);
};

const EventsTypePanel = ({ disabled, ...props }) => {
  const { record } = props;
  const eventTypes = useMemo(() => {
    return {
      items: record?.eventTypes?.items?.filter((et) => et.active === "true"),
    };
  }, [record]);

  if (disabled) return <EventsTypeShow {...props} eventTypes={eventTypes} />;
  return <EventsTypeList {...props} eventTypes={eventTypes} />;
};

const EventsTypeList = (props) => {
  const { eventTypes, history } = props;
  const backPath = [history.location.pathname + history.location.search];

  const handleCreate = () => {
    deepRedirect(history, `/eventTypes/create`, backPath);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Labeled label="Event Types" fullWidth>
          <SortedArrayField
            {...props}
            record={eventTypes}
            source="items"
            sort={{ field: "name", order: "ASC" }}
          >
            <Datagrid
              bulkActionButtons={false}
              rowClick={(jsonRecord, basePath, record) =>
                handleEdit({ ...props, record, backPath })
              }
            >
              <TextField source="name" />
              <TextField source="duration" label="Duration (mins)" />
              <TextField source="numberOfResources" label="Max. Bookings" />
              <TextField source="resourceName" label="Resource Name" />
              <TextField source="active" />
              <EditButton {...props} />
            </Datagrid>
          </SortedArrayField>
        </Labeled>
      </Grid>
      <Grid item xs={12}>
        <Button label="Add" color="default" onClick={handleCreate}>
          <AddIcon />
        </Button>
      </Grid>
    </Grid>
  );
};

const EditButton = (props) => {
  return (
    <Button
      label="Edit"
      size="small"
      color="primary"
      // onClick= rowClick handles redirect
    >
      <EditIcon />
    </Button>
  );
};

const EventsTypeShow = ({ eventTypes, ...props }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Labeled label="Event Types" fullWidth>
          <SortedArrayField
            {...props}
            record={eventTypes}
            source="items"
            sort={{ field: "name", order: "ASC" }}
          >
            <Datagrid>
              <TextField source="name" />
              <TextField source="duration" label="Duration (mins)" />
              <TextField source="numberOfResources" label="Max. Bookings" />
              <TextField source="resourceName" label="Resource Name" />
            </Datagrid>
          </SortedArrayField>
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default EventsTypePanel;
